module.exports = __webpack_public_path__ + "img/scene-1.81acf02.png";